import React from "react";
import { DownArrowIcon } from "../../Icons";
import { useSelector } from "react-redux";

const AccountDropdown = ({ activeAccount }) => {
  const { name } = useSelector((state) => state.ownCompany.company);

  return (
    <>
      {activeAccount && (
        <div className="account-dropdown-wrapper">
          <div className="flex">
            <img
              src={activeAccount?.logo}
              alt="flag"
              className="account-dropdown-flag"
            />
            <div className="account-dropdown-info">
              <p className="account-dropdown-number">
                {activeAccount.account_number}
              </p>
              <p className="account-dropdown-currency">
                {activeAccount.currency_code} · {name}
              </p>
            </div>
          </div>
          <div className="account-dropdown-icon">
            <DownArrowIcon className="h-5 w-5" />
          </div>
        </div>
      )}
    </>
  );
};

export default AccountDropdown;
